import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './formFieldset.scss'

const FormFieldset = ({ children, legend, spacing, description }) => (
	<fieldset
		className={classNames(
			'c-form-fieldset',
			spacing && `c-form-fieldset--spacing-${spacing}`
		)}
	>
		{legend && (
			<legend className="c-form-fieldset__legend">{legend}</legend>
		)}
		{description && (
			<p className="c-form-fieldset__description">{description}</p>
		)}
		{children}
	</fieldset>
)

FormFieldset.propTypes = {
	children: PropTypes.node,
	legend: PropTypes.string,
	description: PropTypes.node,
	spacing: PropTypes.oneOf(['narrow', 'default']),
}

FormFieldset.defaultProps = {
	children: null,
	legend: null,
	description: null,
	spacing: 'default',
}

export default FormFieldset
